(function () {
  if (window.__mpWishlistInit) return;
  window.__mpWishlistInit = true;

  var key = 'mp-wishlist-products';

  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (error) {}
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function sync() {
    var items = read();
    var handles = items.map(function (item) { return item.handle; });

    document.querySelectorAll('[data-mp-wishlist]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = handles.indexOf(handle) !== -1;
      button.classList.toggle('is-wished', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('.mp-wishlist-count').forEach(function (badge) {
      var count = items.length;
      var label = badge.querySelector('span[aria-hidden="true"]');
      if (label) label.textContent = count;
      badge.hidden = count === 0;
    });
  }

  function ensureDrawer() {
    var existing = document.querySelector('.mp-wishlist-drawer');
    if (existing) return existing;

    var drawer = document.createElement('div');
    drawer.className = 'mp-wishlist-drawer';
    drawer.hidden = true;
    drawer.innerHTML = [
      '<button class="mp-wishlist-drawer__overlay" type="button" data-mp-wishlist-close aria-label="Close wishlist"></button>',
      '<aside class="mp-wishlist-drawer__panel" aria-label="Wishlist">',
        '<div class="mp-wishlist-drawer__header">',
          '<h2>Saved for later</h2>',
          '<button type="button" data-mp-wishlist-close aria-label="Close wishlist">×</button>',
        '</div>',
        '<div class="mp-wishlist-drawer__body" data-mp-wishlist-body></div>',
      '</aside>'
    ].join('');
    document.body.appendChild(drawer);

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-mp-wishlist-close]')) {
        drawer.hidden = true;
        drawer.classList.remove('is-open');
      }
    });

    return drawer;
  }

  function openDrawer() {
    var drawer = ensureDrawer();
    var body = drawer.querySelector('[data-mp-wishlist-body]');
    var items = read();

    if (body) {
      if (!items.length) {
        body.innerHTML = '<p class="mp-wishlist-drawer__empty">No saved totes yet. Tap the heart on any product to keep it here.</p>';
      } else {
        body.innerHTML = items.map(function (item) {
          var title = item.title || 'Saved product';
          var url = item.url || '#';
          var image = item.image ? '<img src="' + escapeAttr(item.image) + '" alt="" loading="lazy">' : '<span class="mp-wishlist-drawer__thumb" aria-hidden="true"></span>';
          return '<div class="mp-wishlist-drawer__row">'
            + '<a class="mp-wishlist-drawer__item" href="' + escapeAttr(url) + '">' + image + '<span><strong>' + escapeHtml(title) + '</strong><small>View product</small></span></a>'
            + '<button type="button" class="mp-wishlist-drawer__remove" data-mp-wishlist-remove="' + escapeAttr(item.handle) + '" aria-label="Remove ' + escapeAttr(title) + ' from wishlist">×</button>'
            + '</div>';
        }).join('');
      }
    }

    drawer.hidden = false;
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mp-wishlist]');
    if (!button) return;
    event.preventDefault();

    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var items = read();
    var existingIndex = items.findIndex(function (item) { return item.handle === handle; });
    if (existingIndex > -1) {
      items.splice(existingIndex, 1);
    } else {
      items.push({
        handle: handle,
        title: button.getAttribute('data-product-title') || '',
        url: button.getAttribute('data-product-url') || '#',
        image: button.getAttribute('data-product-image') || ''
      });
    }

    write(items);
    sync();
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-mp-wishlist-link]');
    if (!link) return;
    event.preventDefault();
    openDrawer();
  });

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-mp-wishlist-remove]');
    if (!removeButton) return;
    event.preventDefault();

    var handle = removeButton.getAttribute('data-mp-wishlist-remove');
    var items = read().filter(function (item) { return item.handle !== handle; });
    write(items);
    sync();
    openDrawer();
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.target.closest('a, button, input, select, textarea, summary, label, [role="button"], [data-mp-wishlist]')) return;

    var card = event.target.closest('.mp-fc-card, .card-wrapper');
    if (!card) return;

    var link = card.querySelector('a[href]:not([href="#"])');
    if (!link || !link.href) return;
    window.location.href = link.href;
  });

  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
